export default __webpack_public_path__ + "static/27f5855e-1f73-42cc-a083-cb0f319ea42a-79b93f717676e6cc8fc25385ce54d32a.woff2";